import { OnChanges, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { BsModalRef } from "ngx-bootstrap";
import { FormBuilder, Validators } from '@angular/forms';
var JobHoldAbortFocComponent = /** @class */ (function () {
    function JobHoldAbortFocComponent(sidePanelModalRef, fb) {
        this.sidePanelModalRef = sidePanelModalRef;
        this.fb = fb;
        this.title = '';
        this.labelType = '';
        this.select2Config = {};
        this.bsDateConfig = {};
    }
    JobHoldAbortFocComponent.prototype.ngOnInit = function () {
        this.onClose = new Subject();
        this.select2Config = {
            width: '100%'
        };
        this.jobForm = this.fb.group({
            reason: ['', Validators.required],
        });
    };
    JobHoldAbortFocComponent.prototype.ngOnChanges = function (changes) {
    };
    JobHoldAbortFocComponent.prototype.onSubmit = function () {
        this.onClose.next(this.jobForm.value);
        this.sidePanelModalRef.hide();
    };
    return JobHoldAbortFocComponent;
}());
export { JobHoldAbortFocComponent };
